import { dictionaryPlannerRoutine } from '@modules/planning/children/by-date/actions';
import { DictionariesEndpoint, Dictionary, Keys } from '@common/types';
import { Dispatch } from 'redux';

export const handleCopyRow =
  ({ dispatch }: { dispatch: Dispatch }): (({ dictionary, rows }: { dictionary: Dictionary; rows: Keys }) => void) =>
  ({ rows: ids, dictionary }) => {
    dispatch(dictionaryPlannerRoutine({ dictionary, operation: DictionariesEndpoint.Clone, ids, dictionaryFetching: true }));
  };
